module.exports = __webpack_public_path__ + "static/media/38.cc0a4794.png";